var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pushEventInfo, pushPageErrorInfo } from '../analytics';
var buildFulfillmentTypeSettings = function (fulfillmentType) {
    var _a;
    var map = {
        ShipToHome: 'sth',
        BuyOnlineShipToStore: 'boss',
        BuyOnlinePickupInStore: 'bopis',
        BuyOnlineDeliverFromStore: 'bodfs',
        Appliance: 'appl',
        DFS: 'unknown',
        DirectDelivery: 'unknown',
        WillCallFulfillment: 'unknown',
        MISC: 'unknown',
        CanceledItems: 'unknown',
        Additional: 'unknown',
        InStorePurchase: 'unknown',
        Returned: 'unknown',
    };
    var active = (_a = map[fulfillmentType !== null && fulfillmentType !== void 0 ? fulfillmentType : '']) !== null && _a !== void 0 ? _a : 'unknown';
    var keys = ['sth', 'boss', 'bopis', 'bodfs', 'appl', 'unknown'];
    return ('orders:' +
        keys.map(function (key) { return "".concat(key, ":").concat(key === active ? 'y' : 'n'); }).join('|'));
};
export var TrackEditDeliveryAddressAnalytics = function (settings, category, fulfillmentType) {
    pushEventInfo(__assign({ category: { primaryCategory: category }, eventInfo: { eventName: 'my account settings' }, myAccount: {
            settings: settings,
        } }, (fulfillmentType && {
        fulfillmentType: buildFulfillmentTypeSettings(fulfillmentType),
    })));
};
export var TrackErrorPageEditDeliveryAddressAnalytics = function (pageSection, message, code) {
    if (code === void 0) { code = 'n/a'; }
    var pageError = {
        type: 'system',
        displayType: 'inline',
        pageSection: pageSection,
        message: message,
        code: code,
    };
    pushPageErrorInfo(pageError);
};
export var TrackErrorEventEditDeliveryAddressAnalytics = function (pageSection, errCode, errMessage, type, displayType) {
    if (displayType === void 0) { displayType = 'inline'; }
    pushEventInfo({
        category: {
            primaryCategory: 'error',
        },
        eventInfo: {
            eventName: 'post page error',
            error: [
                {
                    type: type,
                    displayType: displayType,
                    pageSection: pageSection,
                    code: errCode,
                    message: errMessage,
                },
            ],
        },
    });
};
